import { isDefaultLink } from "./Footer/Footer.utils";
import type { StoryblokLink } from "./types";

// TODO: Do refactoring after clenup

const isStoryLinkType = (linktype: StoryblokLink["linktype"]) => linktype === "story";
const isUrlLinkType = (linktype: StoryblokLink["linktype"]) => linktype === "url";

/**
 * Prefixes a string with a slash if it is a default link and has a story link type.
 *
 * @param source - The string to prefix with a slash.
 * @param linktype - The link type of the Storyblok link.
 * @returns The original string with a slash prefix if it meets the specified conditions, otherwise the original string.
 */
export const prefixWithSlash = (source: string, linktype: StoryblokLink["linktype"]) =>
  isDefaultLink(source) && isStoryLinkType(linktype) && !source.startsWith("/") ? `/${source}` : source;

/**
 * Resolves a link source mismatch (server/client) by appending a trailing slash if it is missing.
 * @param source - The source string to resolve.
 * @param linktype - The link type of the Storyblok link.
 * @returns The resolved source string with a trailing slash.
 */
const resolveLinkSourceMismatch = (source: string, linktype: StoryblokLink["linktype"]) =>
  isUrlLinkType(linktype) || source.endsWith("/") ? source : `${source}/`;

/**
 * Returns the source URL of a Storyblok link.
 * @param link - The Storyblok link object.
 * @returns The cached URL or URL of the link, or an empty string if both are undefined.
 */
export const getLinkSource = (link: StoryblokLink) => {
  const linkSource = link?.cached_url || link?.url || "";
  const linktype = link?.linktype;

  const resolvedLinkSource = resolveLinkSourceMismatch(linkSource, linktype);

  return prefixWithSlash(resolvedLinkSource, linktype);
};
